<template>
  <div id="rest-select">
     <h1>Enter Access Code</h1>
     <access-form />
  </div>
</template>

<script>

import AccessForm from '@/components/ui/restaurant-select/AccessForm'
export default {
  name: 'RestaurantSelectPage',
  components: {
    AccessForm
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  div#rest-select {
    padding: 40px; 
    h1 {
      font-size: 32px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RestaurantSelectPage.vue